import { ApiResponsePreviewComment } from "../../Infrastructure/Services/PostService.types";
import { PreviewComment } from "../Components/Post/Post.types";
import { mapToEntityReactions } from "../../Infrastructure/Persistence/Reactions";

export function mapPreviewComment(
    previewComment: ApiResponsePreviewComment,
): PreviewComment {
    return {
        content: previewComment.content,
        createdAt: previewComment.createdAt,
        createdBy: previewComment.createdBy,
        deletedAt: previewComment.deletedAt,
        id: previewComment.id,
        images: previewComment.images,
        isOwn: previewComment.isOwn,
        postId: previewComment.postId,
        releasedAt: previewComment.releasedAt,
        suspendedAt: previewComment.suspendedAt,
        updatedAt: previewComment.updatedAt,
        commentReactions: mapToEntityReactions(previewComment.reactionCount),
        linkoutUrl: previewComment.linkoutUrl,
        isEditorial: previewComment.isEditorial,
    };
}
